module.exports = __webpack_public_path__ + "img/superiority3.02ce477.png";